import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { CardRow } from "../Cards/CardRow";
import { BodyTextM, HeadingM, HeadingS, HeadingXL } from "../Typography";

export const Wrapper = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        alignItems: "flex-start",
    }),
);

export const FullWidthForm = styled("form")(({ theme }) =>
    theme.unstable_sx({
        width: "100%",
    }),
);

export const Title = styled(HeadingXL)(({ theme }) =>
    theme.unstable_sx({
        fontWeight: theme.typography.fontWeightBold,
        mb: theme.spacing(5),
    }),
);

export const Paragraph = styled(BodyTextM)(({ theme }) =>
    theme.unstable_sx({
        mb: theme.spacing(3),
    }),
);

export const Card = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        textAlign: "left",
    }),
);

export const WhatToChangeCardRow = styled(CardRow)(({ theme }) =>
    theme.unstable_sx({
        gap: { xs: 4 },
        width: "100%",
    }),
);

export const AlLeastOneErrorWrapper = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        alignItems: "stretch",
        width: "100%",
        mt: theme.spacing(2),
    }),
);

export const CurrentAllocationSection = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        mb: theme.spacing(5),
        width: "100%",
    }),
);

export const CurrentAllocationTitle = styled(HeadingM)(({ theme }) =>
    theme.unstable_sx({
        mb: theme.spacing(2),
        fontWeight: theme.typography.fontWeightBold,
    }),
);

export const SavingsInfo = styled(BodyTextM)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        textAlign: "right",
        fontWeight: theme.typography.fontWeightMedium,
    }),
);

export const AllocationGrid = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        gap: theme.spacing(4),
        width: "100%",
        alignItems: "flex-start",
    }),
);

export const AllocationColumn = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
        flex: 1,
    }),
);

export const AllocationColumnHeader = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        mb: theme.spacing(2),
    }),
);

export const AllocationColumnTitle = styled(HeadingS)(({ theme }) =>
    theme.unstable_sx({
        fontWeight: theme.typography.fontWeightBold,
        m: 0,
        alignSelf: "center",
    }),
);

export const AllocationColumnTitleWrapper = styled("div")(({ theme }) =>
    theme.unstable_sx({
        mt: theme.spacing(4),
        mb: theme.spacing(4),
    }),
);
